/* eslint-disable no-underscore-dangle */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCorrelationId } from '../../utils/telemetryUtils';
import { selectMobileNumber, selectMainPortal } from '../../selectors';
import { portalTypes } from '../../config';
import startupConfig from '../../config/startupConfig';

const Mouseflow = () => {
  const portal = useSelector(selectMainPortal);
  const mobileNumber = useSelector(selectMobileNumber);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const configuration = startupConfig.get();
    if (!initialized && configuration && portal) {
      let mfKey;
      if (portal === portalTypes.ClientPortal) {
        mfKey = configuration.clientPortalMfKey;
      } else if (portal === portalTypes.ShiftPayments) {
        mfKey = configuration.shiftPaymentsMfKey;
      }
      if (mfKey) {
        window._mfq = window._mfq || [];

        // eslint-disable-next-line func-names
        const mf = document.createElement('script');
        mf.type = 'text/javascript';
        mf.defer = true;
        mf.src = `//cdn.mouseflow.com/projects/${mfKey}.js`;
        document.getElementsByTagName('head')[0].appendChild(mf);
        window._mfq.push(['setVariable', 'reg-correlation-id', getCorrelationId()]);
        window._mfq.push(['tag', 'Registration']);
        setInitialized(true);
      }
    }
  }, [portal, initialized]);

  useEffect(() => {
    if (initialized && mobileNumber) {
      window._mfq.push(['identify', mobileNumber]);
      window._mfq.push(['setVariable', 'mobileNumber', mobileNumber]);
    }
  }, [mobileNumber, initialized]);

  return null;
};

export default Mouseflow;
